import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function WeeklySummary({ weeklySummary, onOpenModal, loading = false }) {
  const hasContent = weeklySummary && (typeof weeklySummary === 'object' ? weeklySummary.teaser : weeklySummary);
  
  return (
    <div 
      className="relative overflow-hidden rounded-[22px] h-28 cursor-pointer group"
      style={{ boxShadow: '0 2px 6px rgba(0,0,0,0.06)' }}
      onClick={() => hasContent && onOpenModal()}
    >
      <img 
        src="/assets/images/insights%20image%20header.png" 
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
        onError={(e) => {
          console.error('Image not found at:', e.target.src);
          e.target.style.display = 'none';
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-white/20 via-transparent to-transparent pointer-events-none z-0" />
      <div className="flex flex-col justify-between h-full p-5 relative z-10">
        <div className="flex-1">
          <h2 className="text-xl font-semibold mb-1 tracking-tight" style={{ color: '#111111' }}>Your Weekly Summary</h2>
          {loading && !hasContent ? (
            <p className="text-sm leading-relaxed animate-pulse" style={{ color: '#999999' }}>
              Loading your summary...
            </p>
          ) : (
            <p className="text-sm leading-relaxed" style={{ color: '#111111' }}>
              {typeof weeklySummary === 'object' 
                ? weeklySummary.teaser 
                : (weeklySummary || "Generating your weekly summary...")}
            </p>
          )}
        </div>
        {hasContent && !loading && (
          <div className="mt-2">
            <span className="text-xs font-medium text-[#7C3AED] group-hover:text-[#A78BFA] transition-colors flex items-center gap-1">
              Read more
              <ArrowRight size={12} />
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

